"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _ReadOnlyField = require("../ReadOnlyField");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["aria-label", "children", "dataTestId", "disabled", "error", "fullWidth", "helperText", "readOnly", "required", "onChange", "label", "inlineLabel", "margin", "name", "SelectDisplayProps", "inputProps", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var findChildByValue = function findChildByValue(_ref) {
  var children = _ref.children,
      value = _ref.value;

  var childrenArray = _react.Children.toArray(children);

  var child = childrenArray.find(function (menuItem) {
    return /*#__PURE__*/(0, _react.isValidElement)(menuItem) && menuItem.props.value === value;
  });
  return child ? child : null;
};

var SelectField = function SelectField(_ref2) {
  var ariaLabel = _ref2["aria-label"],
      children = _ref2.children,
      dataTestId = _ref2.dataTestId,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      helperText = _ref2.helperText,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      _ref2$required = _ref2.required,
      required = _ref2$required === void 0 ? false : _ref2$required,
      _onChange = _ref2.onChange,
      label = _ref2.label,
      _ref2$inlineLabel = _ref2.inlineLabel,
      inlineLabel = _ref2$inlineLabel === void 0 ? false : _ref2$inlineLabel,
      margin = _ref2.margin,
      name = _ref2.name,
      SelectDisplayProps = _ref2.SelectDisplayProps,
      inputProps = _ref2.inputProps,
      value = _ref2.value,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var labelId = (0, _react.useMemo)(function () {
    return (0, _utilities.generateId)();
  }, []);
  var helperTextId = (0, _react.useMemo)(function () {
    return (0, _utilities.generateId)();
  }, []);

  if (readOnly) {
    var child = findChildByValue({
      children: children,
      value: value
    });
    var content = child ? child.props.label : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReadOnlyField.ReadOnlyField, {
      content: content,
      label: label
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, _objectSpread(_objectSpread({
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    margin: margin,
    required: required
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      display: inlineLabel ? "flex" : "inline",
      alignItems: "center",
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputLabel, {
        id: labelId,
        shrink: true,
        sx: {
          marginRight: inlineLabel ? "1.5rem" : 0
        },
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Select, {
        sx: {
          width: fullWidth ? "100%" : "10rem",
          marginTop: inlineLabel ? "0 !important" : "0.5rem"
        },
        MenuProps: {
          anchorOrigin: {
            horizontal: "left",
            vertical: "bottom"
          },
          MenuListProps: {
            sx: {
              padding: function padding(theme) {
                return "".concat(theme.spacing(2), " ").concat(theme.spacing(0));
              }
            }
          },
          transformOrigin: {
            horizontal: "left",
            vertical: "top"
          }
        },
        SelectDisplayProps: _objectSpread({
          // @ts-ignore This is fine: https://github.com/mui-org/material-ui/issues/20160
          "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : null
        }, SelectDisplayProps),
        "aria-describedby": helperTextId,
        displayEmpty: true,
        inputProps: _objectSpread({
          "aria-label": ariaLabel
        }, inputProps),
        labelId: labelId,
        name: name,
        onChange: function onChange(e, child) {
          if (_onChange) {
            _onChange(e, child);
          }
        },
        readOnly: readOnly,
        renderValue: function renderValue(value) {
          var child = findChildByValue({
            children: children,
            value: value
          });
          if (!child) return null;
          var newProps = {
            button: "false",
            component: "span",
            disabled: disabled,
            disableGutters: true,
            indented: false,
            noWrap: true,
            role: "presentation",
            sx: {
              "&:hover": {
                backgroundColor: "transparent"
              },
              display: "inline",
              height: "14px",
              // Fixes input height to 30px
              lineHeight: 1,
              // Fixes input height to 30px
              padding: 0
            }
          };
          return /*#__PURE__*/(0, _react.cloneElement)(child, newProps);
        },
        value: value,
        children: children
      })]
    }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormHelperText, {
      children: helperText,
      id: helperTextId
    })]
  }));
};

var _default = SelectField;
exports.default = _default;